module.exports = __webpack_public_path__ + "media/31.79f333a2.mp3";